import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { ImageTransform, ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';

const toDataURL = async (url: string) => {
  const response = await fetch(url, {
    // workaround issue in Chrome where cache causes CORS to fail
    headers: { "Cache-Control": 'no-cache' },
  });
  const blob = await response.blob();

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  });
};

@Component({
  selector: 'my-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.sass']
})
export class MyImageCropperComponent implements OnChanges, OnDestroy {
  @ViewChild('imageCropper', { static: true }) imageCropper: ImageCropperComponent;
  @ViewChild('imagePublicInput', { static: true }) imagePublicInput: ElementRef;
  @Input() initialImage?: string = null; // receives initial image if one is available
  @Output() imageChange = new EventEmitter<string>(); // emits cropped image base64 to consumers

  _initialImage?: string = null // reset to null when file input chosen
  fileChangedEvent?: Event = null; // for handling file input
  croppedImage?: string = null; // base64 encoded string
  cropSize: number = 1; // zoom setting bound to p-slider; triggers change to imageTransform
  imageTransform: ImageTransform = { scale: 1 }; // updated by cropSize changes AND on image drag

  ngOnChanges(changes: SimpleChanges): void {
    // assume we only set the first image (file input handled by this component, not consumers)
    // if (changes['initialImage'] && !changes['initialImage'].previousValue) {
      if (this.initialImage.startsWith("http")) {
        toDataURL(this.initialImage)
          .then((dataURL) => {
            this._initialImage = dataURL;
          })
          .catch((err) => {
            console.error("failed to load existing image URL into image-cropper:", err);
          });
      } else {
        this._initialImage = this.initialImage;
      }
    // }
  }

  cropSizeChanged(value: number): void {
    this.imageTransform = { ...this.imageTransform, scale: value };
  }

  fileChangeEvent(event: Event): void {
    this._initialImage = null // nullify to tell ngx-image-cropper to reset
    this.fileChangedEvent = event; // ngx-image-cropper to load from FileEvent
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
    this.imageChange.emit(this.croppedImage);
  }

  loadImageFailed(...args: any) {
    // show message
    console.error('load image failed:', ...args);
  }

  removeImage(): void {
    this._initialImage = null;
    this.imagePublicInput.nativeElement.value = '';
    this.croppedImage = null;
    this.imageChange.emit(null);

    this._initialImage = null;
    this.initialImage = null;
    this.fileChangedEvent = null;
    this.imageCropper.imageFile = null;
  }
  ngOnDestroy(): void {
    this.removeImage()
  }
}
